// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__277ks","productName":"Table_productName__2w75h"};